import { render, staticRenderFns } from "./BSReviewUser.vue?vue&type=template&id=24486b04"
import script from "./BSReviewUser.vue?vue&type=script&lang=js"
export * from "./BSReviewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports